type OnfidoVerificationStatusProps = {
  status: string;
};

type StatusPresentation = {
  label: string;
  dotColor: string;
  backgroundColor: string;
  borderColor: string;
  textColor: string;
};

const defaultStatusPresentation: StatusPresentation = {
  label: 'Unknown status',
  dotColor: '#6b7280',
  backgroundColor: '#f9fafb',
  borderColor: '#e5e7eb',
  textColor: '#374151',
};

function getOnfidoVerificationStatusElements(status: string) {
  switch (status) {
    case 'FINISHED_SUCCESSFULLY':
      return {
        label: 'Finished',
        dotColor: '#14b8a6',
        backgroundColor: '#ecfdf5',
        borderColor: '#99f6e4',
        textColor: '#0f766e',
      };
    case 'FINISHED_SUCCESSFULLY_MANUALLY_UPDATED':
      return {
        label: 'Finished - manually updated',
        dotColor: '#14b8a6',
        backgroundColor: '#ecfdf5',
        borderColor: '#99f6e4',
        textColor: '#0f766e',
      };
    case 'FINISHED_WITH_ERRORS':
      return {
        label: 'Finished with errors',
        dotColor: '#f43f5e',
        backgroundColor: '#fff1f2',
        borderColor: '#fecdd3',
        textColor: '#be123c',
      };
    case 'FINISHED_WITH_ERRORS_MANUALLY_UPDATED':
      return {
        label: 'Finished with errors - manually updated',
        dotColor: '#f43f5e',
        backgroundColor: '#fff1f2',
        borderColor: '#fecdd3',
        textColor: '#be123c',
      };
    case 'IN_PROGRESS':
      return {
        label: 'In progress',
        dotColor: '#3b82f6',
        backgroundColor: '#eff6ff',
        borderColor: '#bfdbfe',
        textColor: '#1d4ed8',
      };
    case 'NOT_VERIFIED':
      return {
        label: 'Not verified',
        dotColor: '#f59e0b',
        backgroundColor: '#fffbeb',
        borderColor: '#fde68a',
        textColor: '#b45309',
      };
    case 'No checks found':
      return {
        label: 'No checks found',
        dotColor: '#9ca3af',
        backgroundColor: '#f9fafb',
        borderColor: '#e5e7eb',
        textColor: '#4b5563',
      };
    default:
      return {
        ...defaultStatusPresentation,
        label: status || defaultStatusPresentation.label,
      };
  }
}

function OnfidoVerificationStatus({ status }: OnfidoVerificationStatusProps) {
  const { label, dotColor, backgroundColor, borderColor, textColor } = getOnfidoVerificationStatusElements(status);

  return (
    <div
      className="inline-flex items-center rounded-full border px-3 py-1.5 text-xs font-semibold leading-none"
      style={{ backgroundColor, borderColor, color: textColor }}>
      <div className="rounded-full w-2 h-2 mr-2" style={{ backgroundColor: dotColor }} />
      {label}
    </div>
  );
}

export default OnfidoVerificationStatus;
